import {
   GET_WHITELABELS,
  GET_WHITELABELS_SUCCESS,
  GET_WHITELABELS_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  whitelabelDataWithID: [],
};

const getWhitelabelReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_WHITELABELS:
      return { ...state, loading: true };
    case GET_WHITELABELS_SUCCESS:
      return {
        ...state,
        whitelabelDataWithID: action?.payload,
        loading: false,
      };
    case GET_WHITELABELS_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default getWhitelabelReducer;
